/* The cart drawer is the only cart. Safety net: any add-to-cart form that gets submitted without its own handler (a script
   that didn't load, an app's form) is added in place and the drawer opens, instead of the browser going to /cart. Forms
   handled by product-form.js or the buy box have already called preventDefault by the time this runs. */
(function () {
  if (window.__jxCartAddNet) return;
  window.__jxCartAddNet = true;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = new FormData(form);
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      body.append('sections_url', window.location.pathname);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var button = form.querySelector('[type="submit"]');
    if (button) button.setAttribute('aria-disabled', 'true');
    fetch(addUrl, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          var wrap = form.querySelector('.product-form__error-message-wrapper');
          var msg = wrap && wrap.querySelector('.product-form__error-message');
          if (wrap && msg) { msg.textContent = res.description || res.message || ''; wrap.hidden = false; }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: body.get('id'), cartData: res });
        if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(res);
        else window.location.reload();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { if (button) button.removeAttribute('aria-disabled'); });
  });
})();

/* window.jxCartRedraw(): redraws the drawer and the header cart count from the server. Used by assets/jx-gifts.js after it
   changes gift lines. */
(function () {
  if (window.jxCartRedraw) return;

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  window.jxCartRedraw = function () {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    return Promise.all([
      fetch(cartUrl + '?section_id=cart-drawer').then(function (r) { return r.text(); }),
      fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var doc = parse(res[0]);
      var next = doc.querySelector('cart-drawer');
      var cur = document.querySelector('cart-drawer');
      if (next && cur) {
        cur.classList.toggle('is-empty', next.classList.contains('is-empty'));
        var curInner = cur.querySelector('.drawer__inner');
        var nextInner = next.querySelector('.drawer__inner');
        if (curInner && nextInner) curInner.innerHTML = nextInner.innerHTML;
      }
      var bubbleHtml = res[1] && res[1]['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleHtml && bubble) {
        var section = parse(bubbleHtml).querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    });
  };
})();

/* The protection widget mutates real Shopify cart lines asynchronously and emits cart:updated/cart:refresh.
   This drawer is outside a Shopify section, so repaint its two prices from the settled native cart without
   replacing app nodes. Reads only: prices, variants, selling plans and the shopper's toggle stay app-owned. */
(function () {
  'use strict';
  if (window.__jxNativeCartDisplay) return;
  window.__jxNativeCartDisplay = true;

  var revision = 0, timer = null, reading = false, queued = false, observer = null;
  var totalSelector = '.cro-foot__totals > .cro-foot__row:not(.cro-foot__row--savings) .cro-foot__value';
  var feeSelector = '.dsp-protect-inline-toggle .dsp-protect-fee-amount';

  function formatNativeMoney(cents, currency) {
    if (window.jxMoney && window.jxMoneyCurrency === currency) return window.jxMoney(cents); // assets/jx-money.js
    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: 'currency', currency: currency
    }).format(cents / 100);
  }

  function readAmounts(cart) {
    if (!cart || !Array.isArray(cart.items) || !Number.isInteger(cart.total_price) || cart.total_price < 0 ||
        typeof cart.currency !== 'string' || !/^[A-Z]{3}$/.test(cart.currency)) return null;
    var lines = cart.items.filter(function (item) { return item.handle === 'jcked-package-protection'; });
    var protection = 0;
    for (var i = 0; i < lines.length; i++) {
      if (!Number.isInteger(lines[i].final_line_price) || lines[i].final_line_price < 0) return null;
      protection += lines[i].final_line_price;
    }
    return { currency: cart.currency, total: cart.total_price, protection: lines.length ? protection : null };
  }

  function writePrice(element, text, currency) {
    element.setAttribute('data-jx-native-cart-price', currency);
    // Not a .money element: these numbers are already in the shopper's currency.
    element.classList.remove('money');
    element.querySelectorAll('.money').forEach(function (child) { child.classList.remove('money'); });
    if (element.textContent !== text) element.textContent = text;
  }

  function repaint(cart) {
    var amounts = readAmounts(cart);
    var drawer = document.querySelector('cart-drawer');
    if (!amounts || !drawer) return;
    var total = formatNativeMoney(amounts.total, amounts.currency);
    drawer.querySelectorAll(totalSelector).forEach(function (element) {
      writePrice(element, total, amounts.currency);
    });
    // When protection is off, leave its unselected quote to the app. A real line is the charged amount.
    if (amounts.protection !== null) {
      var fee = formatNativeMoney(amounts.protection, amounts.currency);
      drawer.querySelectorAll(feeSelector).forEach(function (element) {
        writePrice(element, fee, amounts.currency);
      });
    }
  }

  function sync() {
    if (reading) { queued = true; return; }
    reading = true;
    var startedAt = revision;
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    cartUrl = cartUrl.replace(/\/$/, '').replace(/\.(?:js|json)$/, '') + '.js';
    Promise.resolve().then(function () {
      return fetch(cartUrl, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    }).then(function (response) {
      if (!response.ok) throw new Error('Native cart read failed');
      return response.json();
    }).then(function (cart) {
      if (startedAt === revision) repaint(cart);
    }).catch(function () {
      // Keep the existing display and app checkout behavior when a cart read fails.
    }).then(function () {
      reading = false;
      if (queued || startedAt !== revision) {
        queued = false;
        if (timer !== null) clearTimeout(timer);
        timer = setTimeout(function () { timer = null; sync(); }, 0);
      }
    });
  }

  function schedule() {
    revision++;
    if (timer !== null) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(); }, 80);
  }

  function isCartMutation(url) {
    try {
      var parsed = new URL(url, window.location.href);
      return parsed.origin === window.location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js|\.json)?\/?$/.test(parsed.pathname);
    } catch (error) { return false; }
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || observer || typeof MutationObserver === 'undefined') return;
    observer = new MutationObserver(function (records) {
      var changed = records.some(function (record) {
        var element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !element || !element.closest('[data-jx-native-cart-price]');
      });
      if (changed) schedule();
    });
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
  }

  // Exact events emitted by the installed Disputely widget after its own mutations.
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
  function onPageShow(event) {
    var navigation = null;
    try {
      if (window.performance && typeof window.performance.getEntriesByType === 'function') {
        navigation = window.performance.getEntriesByType('navigation')[0];
      }
    } catch (error) { /* The persisted event still identifies a BFCache restoration. */ }
    if ((event && event.persisted) || (navigation && navigation.type === 'back_forward')) {
      // A restored document can contain an empty drawer from before checkout even though the native cart
      // still has items. Rebuild the whole page from the server once, including lines, count and checkout.
      // The ensuing navigation is a reload, not back_forward; the per-document guard prevents re-entry.
      if (!window.__jxCartHistoryReloading) {
        window.__jxCartHistoryReloading = true;
        window.location.reload();
      }
      return;
    }
    schedule();
  }
  window.addEventListener('pageshow', onPageShow);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') schedule(); });

  // Completion-only observation also covers a late vendor tier/toggle write. Never wraps fetch or XHR.
  if (typeof PerformanceObserver !== 'undefined') {
    try {
      var networkObserver = new PerformanceObserver(function (list) {
        if (list.getEntries().some(function (entry) { return isCartMutation(entry.name); })) schedule();
      });
      networkObserver.observe({ type: 'resource', buffered: true });
    } catch (error) { /* Existing theme/vendor events and drawer changes remain available. */ }
  }
  observeDrawer();
  schedule();
})();
